<template>
    <div id="main">
        <div class="page page-container">
            <div class="novo-status-comercial">
                <h1 class="title">
                    {{ $t('status-comercial') }}:
                    {{ !sc.idstatuscomercial ? $t('novo-status-comercial') : title }}
                </h1>
                <nav class="breadcrumb" aria-label="breadcrumbs">
                    <ul>
                        <li>
                            <a class="a-inativo">{{ $t('vendas') }}</a>
                        </li>
                        <li>
                            <a class="a-inativo">{{ $t('cadastros') }}</a>
                        </li>
                        <li>
                            <a @click="$router.push({ name: 'status-comerciais' })">{{
                                $t('status-comercial')
                            }}</a>
                        </li>
                        <li>
                            <a aria-current="page">{{
                                !sc.idstatuscomercial ? $t('novo-status-comercial') : title
                            }}</a>
                        </li>
                    </ul>
                </nav>
                <div class="center">
                    <div class="form">
                        <div class="descricao-input">
                            <v-input
                                v-model="sc.descricao"
                                :id="'descricao'"
                                :placeholder="'descricao-do-status-placeholder'"
                                :maxlength="50"
                                :title="'descricao-do-status'"
                                :msg="'msg-campo-obrigatorio'"
                                :invalid="!sc.descricao"
                                :disabled="isSaving"
                                ref="descricaoInput"
                            />
                        </div>
                        <div class="dias-input" v-if="showDias">
                            <v-mask
                                ref="diasInput"
                                :title="'dias-do-status'"
                                :id="'dias'"
                                :type="'text'"
                                v-model="sc.dias"
                                :mask="['###']"
                                :msg="'msg-campo-obrigatorio'"
                                :placeholder="'dias-do-status-placeholder'"
                                :invalid="!sc.dias"
                                :disabled="isSaving"
                            />
                        </div>
                        <!-- <div class="situacao-input input">
                        <label for="situacao" v-text="$t('situacao')" />
                        <v-select ref="situacaoSelect" :selectOnTab="true" :searchable="false" :options="situacoes" :value="situacao" :onChange="updateSituacao" :placeholder="$t('situacao-da-regiao-placeholder')" class="clear"/>
                    </div> -->
                        <div
                            class="info-text"
                            v-if="sc.tipo && (sc.tipo == 'QI' || sc.tipo == 'R')"
                        >
                            {{ $t('msg-status-nao-configuravel') }}
                        </div>
                    </div>
                </div>

                <div class="form-buttons">
                    <button
                        class="delete-btn"
                        type="button"
                        @click="$router.push({ name: 'status-comerciais' })"
                    >
                        {{ $t('voltar') }}
                    </button>
                    <button
                        class="save-btn"
                        type="button"
                        @click="saveStatus()"
                        :disabled="isSaving"
                    >
                        {{ $t('salvar') }}
                        <button-loader :isSaving="isSaving" />
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import StatusComercialService from '@/services/StatusComercialService';
import StatusComercialValidation from '@/services/validations/StatusComercialValidation';

export default {
    data() {
        return {
            sc: {},
            editable: false,
            title: '',
            isSaving: false,
            situacao: { label: 'ativo', id: 1 },
            situacoes: [
                { label: 'ativo', id: 1 },
                { label: 'inativo', id: 0 },
            ],
            showDias: false,
            isUpdate: false,
        };
    },
    created() {
        if (this.$route.params.id) {
            this.isUpdate = true;
        }

        this.permissao = this.hasPermissionAccess('vendas', 'vendas', 'status-comerciais');
        if (this.isUpdate && !this.permissao.update) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'status-comercial' },
            });
        } else {
            if (this.sc != null && this.sc != {}) {
                this.editable = true;
            }

            this.service = new StatusComercialService(this.$http, this.$router);
            this.validation = new StatusComercialValidation(this.$root.msgs);

            if (this.$route.params.id) {
                this.editable = false;
                this.carregarDados(this.$route.params.id);
            }
        }
    },
    mounted() {
        this.$refs.descricaoInput.$refs.typed.focus();
    },
    methods: {
        carregarDados(id) {
            this.$store.commit('addLoader');

            this.service
                .find(id)
                .then((body) => {
                    if (body.content) {
                        this.sc = body.content;
                        this.title = this.sc.descricao;
                        this.situacao = this.getSituacao();

                        if (this.sc.tipo != 'QI' && this.sc.tipo != 'R') {
                            this.showDias = true;
                        }
                    } else {
                        this.$router.push({ name: 'new-status-comercial' });
                    }
                })
                .catch((e) => {
                    console.error('Erro ao carregar status comercial', e);
                })
                .finally((_) => {
                    this.$store.commit('removeLoader');
                });
        },
        getSituacao() {
            return this.situacoes.filter((s) => s.id == this.sc.situacao);
        },
        mapItems(body) {
            let sclist = body.content.map((r) => {
                return {
                    id: r.idstatuscomercial,
                    descricao: r.descricao,
                    dias: r.dias,
                    situacao: r.situacao,
                    excluir: 'excluir-rede',
                    _cellVariants: { excluir: 'col-medium' },
                };
            });
            return sclist;
        },
        updateSituacao(situacao) {
            if (situacao && situacao.id != null) {
                this.sc.situacao = situacao.id;
            }
        },
        saveStatus(redirect = this.redirectToList) {
            this.sc = this.mapTosave(this.sc);
            this.sc.dias = parseInt(this.sc.dias);

            if (this.validation.validate(this.sc, this.$refs)) {
                this.isSaving = true;

                this.service
                    .save(this.sc)
                    .then((body) => {
                        this.$root.showMessage('success', 'msg-status-comercial-salvo');
                        redirect(2);
                    })
                    .catch((e) => {
                        console.error('Erro ao salvar status comercial', e);

                        if (e.body && e.body.message && e.body.message.startsWith('msg')) {
                            this.$root.showMessage('alert', body.message);
                        } else {
                            this.$root.showMessage('error', 'msg-status-comercial-salvo-erro');
                        }
                    })
                    .finally((_) => {
                        this.isSaving = false;
                    });
            }
        },
        redirectToList(time) {
            setTimeout(() => {
                this.$router.push({
                    name: 'status-comerciais',
                });
            }, time * 1000 + 50);
        },
        redirectToEdit(time) {
            setTimeout(() => {
                this.$router.push({
                    name: 'edit-status-comercial',
                    params: { id: this.sc.idstatuscomercial },
                });
            }, time * 1000 + 50);
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 15px 15px 21px;
    height: auto;
}

.page {
    position: relative;
    margin-bottom: 80px;

    .novo-status-comercial {
        position: relative;
        width: 100%;
        margin-bottom: 20px;
        height: 100%;
        padding-top: 0;

        > h1 {
            padding-top: 20px;
            margin-bottom: 0px;
        }
    }

    .info-text {
        margin-top: 1rem;
        width: 100%;
        text-align: center;
        color: $darker-gray-color;
    }
}

.novo-status-comercial .center {
    width: 100%;
    left: 0;
    transform: translateX(0);
    margin: 0;
    box-sizing: border-box;
    padding-right: 20px;
    position: initial;
    padding-bottom: 1rem;
}

.novo-status-comercial .form {
    // display: block;
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    border-radius: 2px;
    text-align: left;

    .descricao-input {
        width: 100%;
        margin-bottom: 0 !important;
        height: 63px !important;
    }
    .dias-input {
        width: 100%;
        margin-bottom: 5px;
        height: 63px !important;
    }
    // .situacao-input {
    //     width: 24.5%;
    //     background-color: white;
    //     border: none;
    //     box-shadow: none;
    //     padding-top: 0;
    //     display: block;
    // }

    .location {
        width: 100%;
        height: auto;
        flex: 1 1 auto;
        margin-top: 20px;
        position: relative;
        min-height: 300px;
        height: auto;
        margin-bottom: 20px;

        .getlocation {
            position: absolute;
            margin-left: 0;
            bottom: -60px;
        }
    }
}

.novo-status-comercial .getlocation {
    color: $sovis-white;
    font-size: 12px;
    text-align: center;
    padding: 15px 40px;
    border: none;
    border-radius: 6px;
    font-weight: 600;
    margin-left: 20px;
    @include gradient-button();
}
</style>
